import { inject, bindable } from 'aurelia-framework';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';
import { Router } from 'aurelia-router';
import { EventAggregator } from 'aurelia-event-aggregator';
import { NotificationEvent } from './notification'

@inject(DataService, Api, Router, EventAggregator)
export class NavOptionMenu {
	/** MARK: Bindables
		=================================
	**/
	@bindable machine_id;
	@bindable prediction_id;
	/** MARK: Components methods
		=================================
	 **/
	constructor(ds, api, router, ea){
		// Services
		this.ds 		= ds;
		this.api		= api;
		this.router		= router;
		this.ea			= ea;
		// Component variables
		this.prediction	= null;
	}

	activate(params){
		this.id = params.id;
	}
	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/
		window.setTimeout( () => {
			this.init();
		}, 300);
		
	}

	detached(){}

	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService

			Exeption => read only
			============================================
		*/
	}


	/** MARK: API Calls
		=================================
	 **/
	
	postSavePrediction(prediction){
		// Creeate request
		let id			= prediction.credentials.muid;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/", "POST");
		let body		= { prediction:prediction };
		request.body	= JSON.stringify(body);
		return this.api.post(request);
	}

	handlePostSavePrediction(response){
		// this.ea.publish(NotificationEvent.PredictionSaved, {"body":"Saved successfully"});
		this.ea.publish(NotificationEvent.PredictionSaved, {"body":"Saved to archive"});
	}

	deletePrediction(prediction){
		let id			= prediction.credentials.muid;
		let pid			= prediction._id;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/"+pid, "DELETE");
		return this.api.remove(request);
	}

	handleDeletePrediction(response){
		// Back to prevoius state (archive)
		this.ea.publish(NotificationEvent.PredictionRemoved);
	}

	postDownloadPrediction(prediction){
		// Creeate request
		let id			= prediction.credentials.muid;
		let pid			= prediction._id;
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/" + pid + "/download/", "POST");
		return this.api.post(request);
	}

	file_download(url){
		let options = {
			headers:{
				'Access-Control-Allow-Origin'	: '*',
			}
		}

		fetch(url, options)
			.then(res => res.blob() )
			.then(blob => {
				let file = window.URL.createObjectURL(blob);
				window.location.assign(file);
			});
	}
	
	handlePostDownloadPrediction(response){
		let file_name	= response.data.file_path;
		// File request
		let request		= new Request("/api/v2/predictions/file_name?", "GET");
		let params  	= new URLSearchParams({ file_name:file_name });
		let file_url 	= request.domain + request.url + params;
		this.file_download(file_url);
		this.ea.publish(NotificationEvent.SysMessage, { body:"Download done!"});
	}

	
	/** MARK: Custom methods
		=================================
	 **/
	// Save smart prdiction
	savePrediction(){
		let prediction = this.ds.app_data.prediction;

		if(prediction){
			this.postSavePrediction(prediction).then(response => {
				this.handlePostSavePrediction(response);
				// Push notification
			});
		}else{
			// Push error notification
			this.ea.publish(NotificationEvent.SysError, { body:"Prediction not found"});
		}
		
	}

	removePrediction(){
		let prediction = this.ds.app_data.prediction;
		this.deletePrediction(prediction).then(response => {
			this.handleDeletePrediction(response);
		});
		
	}
	// Export smart prediction
	downloadPrediction(){
		let prediction = this.ds.app_data.prediction;
		// Download image signal
		this.ea.publish(NotificationEvent.PredictionDownload);
		this.postDownloadPrediction(prediction).then(response => {
			this.handlePostDownloadPrediction(response);
		});
	}

	// Go to Archive
}
